import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import React, { useContext, useState } from "react";

const useEditName = () => {
  const { lead } = useContext(LeadPageContext);

  const [name, setName] = useState<string | null>(null);
  const [editLeadNameModalOpen, setEditLeadNameModalOpen] = useState(false);

  const handleChangeLeadName = (e: React.ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
  };
  return {
    name: {
      editLeadNameModalOpen,
      setEditLeadNameModalOpen,
      handleChangeLeadName,
      state: name,
      setState: setName,
      value: lead?.data?.lead?.name,
    },
  };
};

export default useEditName;
